import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import loadingAnimation from "../loadingAnimation.json";
import Lottie from "lottie-react";
export default function TvShows() {
  const [airingToday, setAiringToday] = useState([]);
  const [onTheAir, setOnTheAir] = useState([]);
  const [popularTvShows, setPopularTvShows] = useState([]);
  const [topRatedTvShows, setTopRatedTvShows] = useState([]);
  const [loading, setLoading]  = useState(true)
  const navigate = useNavigate();

  const options = {
    method: "GET",
    headers: {
      accept: "application/json",
      Authorization:
        "Bearer eyJhbGciOiJIUzI1NiJ9.eyJhdWQiOiI0ZmZhM2UxNGQ0ZjMxOTg1NDk5NGE0ZjRjM2I0ODYwOCIsInN1YiI6IjY1NmNhNzlmZTM4YmQ4MDEzODU3MTRjZiIsInNjb3BlcyI6WyJhcGlfcmVhZCJdLCJ2ZXJzaW9uIjoxfQ.dj5HiwpguntzVOpJVHY1sQ7emIQuESxWfM09tKqS9Ss",
    },
  };

  useEffect(() => {
    // Fetch Airing Today TV Shows
    fetch(
      "https://api.themoviedb.org/3/tv/airing_today?language=en-US&page=1",
      options
    )
      .then((response) => response.json())
      .then((data) => setAiringToday(data.results))
      .catch((err) => console.error(err));

    // Fetch On The Air TV Shows
    fetch("https://api.themoviedb.org/3/tv/on_the_air?language=en-US&page=1", options)
      .then((response) => response.json())
      .then((data) => setOnTheAir(data.results))
      .catch((err) => console.error(err));

    // Fetch Popular TV Shows
    fetch("https://api.themoviedb.org/3/tv/popular?language=en-US&page=1", options)
      .then((response) => response.json())
      .then((data) => setPopularTvShows(data.results))
      .catch((err) => console.error(err));

    // Fetch Top Rated TV Shows
    fetch("https://api.themoviedb.org/3/tv/top_rated?language=en-US&page=1", options)
      .then((response) => response.json())
      .then((data) => setTopRatedTvShows(data.results))
      .then(()=>setLoading(false))
      .catch((err) => console.error(err));
  }, []);
  if(loading){
    return <div className="flex items-center justify-center h-screen">
      <Lottie className="pl-20" animationData={loadingAnimation} height={50} width={50}></Lottie>
    </div>
  }

  return (
    <div className="bg-[#221F1F]">
      {/* Airing Today TV Shows */}
      <div>
        <div className="text-[#867d7d] font-sans font-bold p-3 text-left lg:text-white lg:font-poppins">
          Airing Today
        </div>
        <div className="flex space-x-2 overflow-x-auto px-3 no-scrollbar">
          {airingToday.map((show) => (
            <img
              key={show.id}
              className="w-40 rounded-sm hover:cursor-pointer"
              src={
                show.poster_path
                  ? `https://image.tmdb.org/t/p/original/${show.poster_path}`
                  : 'https://cdn.dribbble.com/users/469978/screenshots/10198884/artboard_4x.jpg'
              }
              alt={show.name}
              title={show.name + ' (' + (show.first_air_date ? show.first_air_date.slice(0, 4) : '-') + ')'}
              onClick={() => navigate(`/playvideo/tv/${show.id}`)}
            />
          ))}
        </div>
      </div>

      {/* On The Air TV Shows */}
      <div>
        <div className="text-[#867d7d] font-sans font-bold p-3 text-left lg:text-white lg:font-poppins">
          On The Air
        </div>
        <div className="flex space-x-2 overflow-x-auto px-3 no-scrollbar">
          {onTheAir.map((show) => (
            <img
              key={show.id}
              className="w-40 rounded-sm hover:cursor-pointer"
              src={
                show.poster_path
                  ? `https://image.tmdb.org/t/p/original/${show.poster_path}`
                  : 'https://cdn.dribbble.com/users/469978/screenshots/10198884/artboard_4x.jpg'
              }
              alt={show.name}
              title={show.name + ' (' + (show.first_air_date ? show.first_air_date.slice(0, 4) : '-') + ')'}
              onClick={() => navigate(`/playvideo/tv/${show.id}`)}
            />
          ))}
        </div>
      </div>

      {/* Popular TV Shows */}
      <div>
        <div className="text-[#867d7d] font-sans font-bold p-3 text-left lg:text-white lg:font-poppins">
          Popular
        </div>
        <div className="flex space-x-2 overflow-x-auto px-3 no-scrollbar">
          {popularTvShows.map((show) => (
            <img
              key={show.id}
              className="w-40 rounded-sm hover:cursor-pointer"
              src={
                show.poster_path
                  ? `https://image.tmdb.org/t/p/original/${show.poster_path}`
                  : 'https://cdn.dribbble.com/users/469978/screenshots/10198884/artboard_4x.jpg'
              }
              alt={show.name}
              title={show.name + ' (' + (show.first_air_date ? show.first_air_date.slice(0, 4) : '-') + ')'}
              onClick={() => navigate(`/playvideo/tv/${show.id}`)}
            />
          ))}
        </div>
      </div>

      {/* Top Rated TV Shows */}
      <div className="pb-5">
        <div className="text-[#867d7d] font-sans font-bold p-3 text-left lg:text-white lg:font-poppins">
          Top Rated
        </div>
        <div className="flex space-x-2 overflow-x-auto px-3 no-scrollbar">
          {topRatedTvShows.map((show) => (
            <img
              key={show.id}
              className="w-40 rounded-sm hover:cursor-pointer"
              src={
                show.poster_path
                  ? `https://image.tmdb.org/t/p/original/${show.poster_path}`
                  : 'https://cdn.dribbble.com/users/469978/screenshots/10198884/artboard_4x.jpg'
              }
              alt={show.name}
              title={show.name + ' (' + (show.first_air_date ? show.first_air_date.slice(0, 4) : '-') + ')'}
              onClick={() => navigate(`/playvideo/tv/${show.id}`)}
            />
          ))}
        </div>
      </div>
      <div className="hidden lg:block text-xs my-3 text-gray-700 absolute bottom-1 left-1/2">Tip: Use Shift+Scroll to scroll horizontally</div>
    </div>
  );
}
